/**
 * A paginação da lista, na URL (p.16).
 *
 * Toda lista do sistema pagina igual, com as mesmas opções, e todo validador
 * de busca precisa ler os mesmos dois parâmetros do mesmo jeito. Três cópias
 * da leitura divergiriam na primeira correção, e a que ficasse para trás
 * aceitaria a página que a outra recusa — numa lista, isso aparece como
 * "a paginação sumiu quando mandei o link".
 *
 * ## O que este módulo NÃO fez
 *
 * Quando ele nasceu havia SETE cópias destas duas constantes no `src/`
 * (`cadastros/busca.ts`, `combustivel/busca.ts`, `equipamentos/busca.ts`,
 * `PaginaEstoque.tsx`, `PaginaManutencao.tsx`, `PlanosDaManutencao.tsx` e
 * mais uma). Ele é usado pelos validadores NOVOS — manutenção, oficina e
 * estoque —, e as cópias antigas ficaram onde estavam: trocá-las não foi
 * pedido, e mudança que ninguém pediu é achado mesmo quando melhora o código.
 * Fica registrado aqui para quem for mexer nelas saber que o lugar existe.
 */

export const PADRAO_POR_PAGINA = 10;
export const OPCOES_POR_PAGINA = [10, 25, 50, 100];

export interface PaginacaoNaUrl {
  readonly pagina?: number;
  readonly porPagina?: number;
}

/**
 * Lê a paginação da URL, descartando o que não serve.
 *
 * O PADRÃO FICA FORA. `?pagina=1&porPagina=10` não diz nada a quem lê o link,
 * e deixaria o endereço de "a lista de sempre" indistinguível do endereço de
 * uma visão escolhida.
 *
 * Valor fora do vocabulário é DESCARTADO, nunca corrigido no chute: a URL é
 * entrada do usuário, e adivinhar o que a pessoa quis dizer é como uma lista
 * passa a mostrar coisa diferente do que o filtro diz.
 */
export function paginacaoDa(entrada: Record<string, unknown>): PaginacaoNaUrl {
  const pagina = Number(entrada['pagina']);
  const porPagina = Number(entrada['porPagina']);
  return {
    ...(Number.isInteger(pagina) && pagina > 1 ? { pagina } : {}),
    ...(OPCOES_POR_PAGINA.includes(porPagina) && porPagina !== PADRAO_POR_PAGINA ? { porPagina } : {}),
  };
}

/** Monta a paginação para navegar, pelo mesmo vocabulário da leitura. */
export function montarPaginacao(estado: {
  readonly pagina: number;
  readonly porPagina: number;
}): PaginacaoNaUrl {
  return {
    ...(estado.pagina > 1 ? { pagina: estado.pagina } : {}),
    ...(estado.porPagina !== PADRAO_POR_PAGINA ? { porPagina: estado.porPagina } : {}),
  };
}

/** O texto livre de um filtro: aparado, e ausente quando vazio. */
export function termoDa(valor: unknown): string | undefined {
  if (typeof valor !== 'string') return undefined;
  const limpo = valor.trim();
  return limpo === '' ? undefined : limpo;
}
